import { Component, EventEmitter, Input, OnInit, Optional, Output, ViewChild } from '@angular/core';
import { OnBoardingService } from '../../services/on-boarding.service';
import { ManageUsersAccountService } from '../../../services/manage-users-account.service';
import { from, zip } from 'rxjs';
import { StaffService } from '../../../services/staff.service';
import { StaffManagementService } from '../../../services/staff-management.service';
import { FormGroup } from '@angular/forms';
import { MatSort } from '@angular/material/sort';
import { filter, flatMap, map, tap, toArray } from 'rxjs/operators';
import { StaffConfirmModel } from '../../../models/StaffConfirmModel';
import { GoogleAnalyticsService } from '../../../services/googleanalytics.service';
import { GoogleAnalyticsEvents } from '../../../models/GoogleAnalyticsEvents';
import { Router } from '@angular/router';
import { StaffMemberUpload } from '../../models/StaffMemberUpload';
import { cloneDeep } from 'lodash';
import { MatDialogRef } from '@angular/material/dialog';
import { AddStaffDialogComponent } from 'src/app/base-layout/components/toolbar/add-staff-dialog/add-staff-dialog.component';

@Component({
  selector: 'app-confirm-staff',
  templateUrl: './confirm-staff.component.html',
  styleUrls: ['./confirm-staff.component.scss']
})
export class ConfirmStaffComponent implements OnInit {
  @Input() usedInApp: boolean;
  @Output() backClicked = new EventEmitter<boolean>(false);
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  staffGroup: FormGroup;
  isValidState = true;
  allStaff: StaffMemberUpload[];
  existingStaffData: StaffMemberUpload[];
  retrieveInitialData = false;
  clientName: string;
  selectedRow: any;
  sendText = false;
  private _analyticsEvents = new GoogleAnalyticsEvents();
  private localStorageKey = 'staffList';
  isChanged = false;

  constructor(
    private _router: Router,
    private _onBoardingService: OnBoardingService,
    private _staffManagementService: StaffManagementService,
    private _staffService: StaffService,
    private _accountService: ManageUsersAccountService,
    private _analyticsService: GoogleAnalyticsService,
    @Optional() public dialogRef: MatDialogRef<AddStaffDialogComponent>
  ) {
  }

  ngOnInit(): void {
    zip(
      this._getClientData(),
      this._getStaff()
    ).subscribe(resp => {
      this.clientName = resp[0].data.clientname;
      this.existingStaffData = cloneDeep(resp[1]);
      if (!this.usedInApp) {
        const staffList = this._onBoardingService.getPartialInfoInLs(this.localStorageKey);
        if (!!staffList && staffList.length > 0) {
          resp[1] = resp[1].map(st => {
            const lsStaff = staffList.filter(sta => st.id === sta.id)[0];
            if (!!lsStaff) {
              return lsStaff;
            }
            return st;
          });
        }
      }

      this.allStaff = cloneDeep(resp[1]);
      this.isChanged = this.checkIfChanged();
      this.retrieveInitialData = true;

      // this._copyDataToExisting();
    });
  }

  goForward() {
    if (!!this.checkIfChanged()) {
      this._saveChangedData();

    }
    const nav = this._onBoardingService.onBoardingNavigation.value;
    this._onBoardingService.updateStateObservable(
      nav.find(item => '/' + item.uri === this._router.url.split('?')[0]).next
    ).pipe(
      tap(() => this._onBoardingService.goForward())
    ).subscribe();
  }

  saveChanges() {
    if (this.usedInApp) {
      this.updateSendText(this.sendText);
      console.log("2", this.sendText)
      this.dialogRef.close(true);
    }
    this._saveChangedData();
  }

  updateSendText(value) {
    this.sendText = value;
    if (this.usedInApp) {
      this.allStaff.map(e => {
        e.sendText = this.sendText;
        e.updated = e.updated ? e.updated : this.sendText;
      }
      )
    }
  }

  checkIfChanged() {
    let changed = false;
    if (this.allStaff && this.allStaff[this.allStaff.length - 1].id && this.existingStaffData) {
      if (this.allStaff.length === this.existingStaffData?.length
        && this.existingStaffData?.filter(e => e.deleted).length === this.allStaff?.filter(e => e.deleted).length
        && this.existingStaffData?.filter(e => !e.deleted).length === this.allStaff?.filter(e => !e.deleted).length
      ) {

        this.existingStaffData?.forEach((item, index) => {
          if (!!this.allStaff[index] && !this._onBoardingService._checkObjects(item, this.allStaff[index])) {
            changed = true;
            return;
          }
        });
      } else {
        changed = true;
      }
    }
    return changed;
  }

  private _copyDataToExisting() {
    this.existingStaffData = cloneDeep(this.allStaff);
  }


  private _saveChangedData() {
    this.isValidState = false;
    const deletedStaffMembers = this.allStaff.filter(item => item.deleted === true);
    const modifiedStaffMembers = this.allStaff.filter(item => item.updated === true);
    zip(
      from(modifiedStaffMembers).pipe(
        flatMap(e => this._staffService.generalStaffUpdate({
          staffid: e.id,
          firstname: e.firstname,
          lastname: e.lastname,
          phonenumber: e.phonenumber,
          stafftypeid: e.stafftypeid,
          sendText: this.usedInApp ? this.sendText : false
        })),
        toArray()),
      from(deletedStaffMembers).pipe(
        flatMap(e => this._staffService.removeStaffMember(e.id)),
        toArray()),
    ).subscribe(item => {
      // Copying the current staff array to object that we save initial data
      this._copyDataToExisting();
      this.isChanged = false;
      this._onBoardingService.removePartialInfoInLs(this.localStorageKey);
      this.isValidState = true;
    }, error => {
      this.isValidState = true;
    });
  }

  private _sortingDataAccessor(item, property) {
    if (property.includes('.')) {
      return property.split('.')
        .reduce((object, key) => object[key], item);
    }
    return item[property];
  }

  private _getClientData() {
    return this._accountService.getClientData().pipe();
  }

  private _getStaff() {
    return this._staffManagementService
      .getAllStaff({ startDate: '', endDate: '' })
      .pipe(
        filter((item) => !!item.data),
        flatMap((item) => item.data),
        filter((item) => !!item.active && item.agencyName !== "IntelyCare"),
        map((item) => ({
          id: item.staffId,
          firstname: item.firstName,
          lastname: item.lastName,
          phonenumber: item.phoneNumber,
          stafftypeid: item.staffTypeId,
          updated: false,
          deleted: false,
        })),
        toArray()
      );
  }

  private _filterStaff(): (data: any, filter: string) => boolean {
    const filterFunction = function (data): boolean {
      return !data.deleted;
    };
    return filterFunction;
  }

  private _updateGoogleAnalytics(oldStaffData: StaffConfirmModel, newStaffData: StaffConfirmModel) {
    if (oldStaffData.firstname !== newStaffData.firstname) {
      //  @TODO update for first name
      this._analyticsService.eventEmitter(this._analyticsEvents.onboarding.category,
        this._analyticsEvents.onboarding.action.edit_firstname.name,
        this._analyticsEvents.onboarding.action.edit_firstname.label
      );
    }
    if (oldStaffData.lastname !== newStaffData.lastname) {
      //  @TODO update for last name
      this._analyticsService.eventEmitter(this._analyticsEvents.onboarding.category,
        this._analyticsEvents.onboarding.action.edit_lastname.name,
        this._analyticsEvents.onboarding.action.edit_lastname.label
      );
    }
    if (oldStaffData.mobile !== newStaffData.mobile) {
      //  @TODO update for mobile no
      this._analyticsService.eventEmitter(this._analyticsEvents.onboarding.category,
        this._analyticsEvents.onboarding.action.edit_phonenumber.name,
        this._analyticsEvents.onboarding.action.edit_phonenumber.label
      );
    }
  }

  getUpdatedData(event) {
    this.allStaff = cloneDeep(event);
    this.isChanged = this.checkIfChanged();
  }


  goBack() {
    this.backClicked.emit(true);
  }
}
